import { useState, useEffect } from "react"

const messages = [
  "Brezplačna dostava nad 45 €",
  "Kupi posamezne ploščice ali celoten komplet",
  "CE certifikat | EN71 testirano | Starost 3+",
]

const AnnouncementBar = () => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    document.documentElement.style.setProperty("--announcement-height", "36px")
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="fixed left-0 right-0 top-0 z-50 overflow-hidden bg-primary text-primary-foreground">
      <div className="container mx-auto flex items-center justify-center px-4 py-2">
        <p className="text-center text-sm font-medium transition-opacity duration-300" key={index}>
          {messages[index]}
        </p>
      </div>
    </div>
  )
}

export default AnnouncementBar
